import * as RollingDatePointOptionValues from './RollingDatePointOptionValues';
export const TODAY = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.TODAY',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.TODAY',
  value: RollingDatePointOptionValues.TODAY
};
export const YESTERDAY = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.YESTERDAY',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.YESTERDAY',
  value: RollingDatePointOptionValues.YESTERDAY
};
export const TOMORROW = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.TOMORROW',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.TOMORROW',
  value: RollingDatePointOptionValues.TOMORROW
};
export const THIS_WEEK = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.THIS_WEEK',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.THIS_WEEK',
  value: RollingDatePointOptionValues.THIS_WEEK
};
export const LAST_WEEK = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.LAST_WEEK',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.LAST_WEEK',
  value: RollingDatePointOptionValues.LAST_WEEK
};
export const NEXT_WEEK = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.NEXT_WEEK',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.NEXT_WEEK',
  value: RollingDatePointOptionValues.NEXT_WEEK
};
export const THIS_MONTH = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.THIS_MONTH',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.THIS_MONTH',
  value: RollingDatePointOptionValues.THIS_MONTH
};
export const LAST_MONTH = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.LAST_MONTH',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.LAST_MONTH',
  value: RollingDatePointOptionValues.LAST_MONTH
};
export const NEXT_MONTH = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.NEXT_MONTH',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.NEXT_MONTH',
  value: RollingDatePointOptionValues.NEXT_MONTH
};
export const THIS_QUARTER = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.THIS_QUARTER',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.THIS_QUARTER',
  value: RollingDatePointOptionValues.THIS_QUARTER
};
export const LAST_QUARTER = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.LAST_QUARTER',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.LAST_QUARTER',
  value: RollingDatePointOptionValues.LAST_QUARTER
};
export const NEXT_QUARTER = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.NEXT_QUARTER',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.NEXT_QUARTER',
  value: RollingDatePointOptionValues.NEXT_QUARTER
};
export const THIS_YEAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.THIS_YEAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.THIS_YEAR',
  value: RollingDatePointOptionValues.THIS_YEAR
};
export const LAST_YEAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.LAST_YEAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.LAST_YEAR',
  value: RollingDatePointOptionValues.LAST_YEAR
};
export const NEXT_YEAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.help.NEXT_YEAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.NEXT_YEAR',
  value: RollingDatePointOptionValues.NEXT_YEAR
};